function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4C0 1.79086 1.79086 0 4 0H12.9011C13.8472 0 14.7626 0.33534 15.4848 0.946455L20.0274 4.79016C20.5691 5.2485 21.2557 5.5 21.9652 5.5H35.5C37.7091 5.5 39.5 7.29086 39.5 9.5V13.5H40.9384C42.8902 13.5 44.3222 15.3342 43.8489 17.2276L40.0382 32.4701C39.5931 34.2508 37.9931 35.5 36.1577 35.5H3C1.34315 35.5 0 34.1569 0 32.5V4ZM37.5 13.5V9.5C37.5 8.39543 36.6046 7.5 35.5 7.5H21.9652C20.7826 7.5 19.6383 7.08082 18.7355 6.31693L14.193 2.47323C13.8318 2.16767 13.3741 2 12.9011 2H4C2.89543 2 2 2.89543 2 4V27.0923L4.92955 16.4394C5.40701 14.7032 6.98571 13.5 8.78637 13.5H37.5ZM2.66004 32.2348C2.48497 32.8715 2.96399 33.5 3.62425 33.5H36.1577C37.0754 33.5 37.8754 32.8754 38.098 31.9851L41.9086 16.7425C42.0664 16.1114 41.589 15.5 40.9384 15.5H8.78637C7.88604 15.5 7.09669 16.1016 6.85796 16.9697L2.66004 32.2348Z",
  fill: "currentColor"
});

var SvgEmptyFolder = function SvgEmptyFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_folder.5de8d2e5.svg";
export { ForwardRef as ReactComponent };